import { kitchenStories } from './kitchenStories';
import { yelp } from './yelp';
import { chatgpt } from './chatgpt';

export const getHeroImageSrc = (study) =>
  study.sections?.find(s => s.type === 'hero-images')?.images?.[0]?.src;

export const caseStudies = [
  chatgpt,
  yelp,
  kitchenStories
];